import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 8,
	viewBox: "0 0 9 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.49865 6.63938L3.32531 4.46604C3.06865 4.20937 3.06865 3.78938 3.32531 3.53271L5.49865 1.35938",
		stroke: "#8E68F7",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFlash;
